// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__EFHy9","select":"Header_select__163m0","clinic":"Header_clinic__1jlL5"};